<template>
  <div id="app">
    <keep-alive><router-view v-if="$route.meta.keepAlive"/></keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    //return console.error('App.mounted',this.$route.name)
    if(!['activity','submission','login','produce','cooperate'].includes(this.$route.name)){
      if(!localStorage.getItem('token')){
        this.$router.replace('/')
        console.log(this.$route)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin:0;
}
body{
  margin:0;
  padding: 0;
}
#app .test-style{
  background: none;
  background-color: #23b092;
}
#app .test-style::after{
  content: "悟空投票";
  font-size: 100px;
  color: rgba(255,255,255,0.1);
  position: absolute;
  bottom:1%;
  right: 1%;
  transform:rotate(-30deg);
  text-shadow: 5px 5px 5px rgba(0,0,0,0.1);
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue